import React from "react";
import { useParams } from "react-router-dom";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import RootItemDetail from "container/itemDetail/RootItemDetail";
import { getEssentialUrl } from "lib/urlQueryParser";

function ItemDetailPage(props) {
  const params = useParams();
  const { itemHash } = params;

  return (
    <AppUpdateCheckpoint>
      <GatewayCheckpoint
        type={"replace"}
        url={getEssentialUrl({ type: "itemDetail" })(itemHash)}
      >
        <RootItemDetail itemHash={itemHash} />
      </GatewayCheckpoint>
    </AppUpdateCheckpoint>
  );
}

export default ItemDetailPage;
